'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import { NavItemEnum, TAB_IDS } from '../../constants/Mon569SidenavConfig';
import breakpoint from '../../utils/responsiveBreakpoints';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
const StyledTabs = styled(UIRouterTabs).withConfig({
  displayName: "SegmentedTabs__StyledTabs",
  componentId: "sc-9qfv28-0"
})(["max-width:1000px;padding-top:10px;margin-left:50px;& > div > div > a{font-size:24px !important;}", ";"], breakpoint.cs(_t || (_t = _`
    display: none;
  `)));

const SegmentedTabs = ({
  isIntersecting,
  selectedNavItem
}) => {
  const hideTabs = selectedNavItem === NavItemEnum.BUNDLE || selectedNavItem === NavItemEnum.CRM;

  const getLangKey = tabId => {
    return isValidI18nKey(`mon569.tabTitle.${selectedNavItem}.${tabId}`) ? selectedNavItem : 'default';
  };

  return /*#__PURE__*/_jsx(StyledTabs, {
    bordered: !hideTabs && isIntersecting,
    children: !hideTabs && Object.keys(TAB_IDS).map(tabId => /*#__PURE__*/_jsx(UIRouterTab, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `mon569.tabTitle.${getLangKey(tabId)}.${tabId}`
      }),
      to: createToObject(`/${selectedNavItem}/${tabId}`)
    }, tabId))
  });
};

export default SegmentedTabs;